import React, { useState } from 'react';

const styles = {
  screen: { position:'fixed', inset:0, background:'#111', display:'flex', alignItems:'center', justifyContent:'center', zIndex:9999 },
  box: { background:'#1e1e1e', border:'1px solid #3a3a3a', borderTop:'3px solid #D60000', borderRadius:4, padding:'48px 40px', width:'100%', maxWidth:360, textAlign:'center' },
  title: { fontFamily:"'Barlow Condensed', sans-serif", fontSize:22, fontWeight:800, textTransform:'uppercase', letterSpacing:'0.08em', color:'#fff', marginBottom:4 },
  sub: { fontSize:11, color:'#666', letterSpacing:'0.1em', textTransform:'uppercase', marginBottom:28 },
  input: { width:'100%', background:'#111', border:'1px solid #3a3a3a', borderRadius:3, padding:'11px 14px', fontFamily:"'Barlow', sans-serif", fontSize:14, color:'#fff', outline:'none', marginBottom:12 },
  btn: { width:'100%', background:'#D60000', border:'none', borderRadius:3, padding:12, fontFamily:"'Barlow Condensed', sans-serif", fontSize:14, fontWeight:700, letterSpacing:'0.1em', textTransform:'uppercase', color:'#fff', cursor:'pointer' },
  error: { color:'#ff5555', fontSize:12, marginTop:10 },
};

export default function Login({ onLogin }) {
  const [pw, setPw] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = () => {
    const ok = onLogin(pw);
    if (!ok) { setError(true); setPw(''); }
  };

  return (
    <div style={styles.screen}>
      <div style={styles.box}>
        <div style={styles.title}>Fortitude Creative</div>
        <div style={styles.sub}>Client Portal — Enter Password</div>
        <input
          type="password"
          placeholder="Password"
          value={pw}
          onChange={e => { setPw(e.target.value); setError(false); }}
          onKeyDown={e => e.key === 'Enter' && handleSubmit()}
          style={styles.input}
        />
        <button onClick={handleSubmit} style={styles.btn}>Enter</button>
        {error && <div style={styles.error}>Incorrect password. Try again.</div>}
      </div>
    </div>
  );
}
